import { Component, EventEmitter, Inject, Input, NgZone, OnDestroy, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { OrganizationComponent } from '../organization/organization.component';
import { OrganizationState } from '../../store/organization.state';
import { HttpResponse } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';
import { AlertDialogType } from '@shared/models/enums/alert-dialog.type';
import { SetNotificationAction } from '@core/store/notification/notification.actions';
import { Store } from '@ngxs/store';

@Component({
    selector: 'hmt-bulk-upload-result',
    templateUrl: './bulk-upload-result.component.html',
    styleUrls: ['./bulk-upload-result.component.scss'],
    standalone: false
})
export class BulkUploadResultComponent implements OnDestroy {

  unsubscribe: Subject<void> = new Subject<void>();
  heading = 'RESOURCE BULK UPLOAD';
  fileIsReadyToDownload = false;

  @Output() downloadFile = new EventEmitter();

  constructor(
    private dialogRef: MatDialogRef<OrganizationState>,
    private ngZone: NgZone,
    private store: Store,
    @Inject(MAT_DIALOG_DATA) public data: {
      organizations?: number;
      divisions?: number;
      humanResources?: number;
      vehicles?: number;
      locations?: number;
      hasFile?: any;
      message?: string;
      errorResponse?: boolean;
      valid?: boolean;
      downloadUrl?: string;
    }
  ) {
    this.fileIsReadyToDownload = !this.data.valid && this.data.errorResponse == null && this.data.hasFile;

    ngZone.run(() => {
      if (this.data.valid) {
        this.heading = 'RESOURCE BULK UPLOAD SUCCESS';
      } else {
        this.heading = 'RESOURCE BULK UPLOAD FAILED';
      }
    });

    // Automatically trigger download if file is ready
    if (this.fileIsReadyToDownload) {
      // Small delay to ensure dialog is rendered before download
      setTimeout(() => {
        this.download();
      }, 300);
    }
  }

  close() {
    this.ngZone.run(() => {
      this.dialogRef.close();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  download() {
    this.downloadFile.emit();
    this.store.dispatch(new SetNotificationAction("Errors were found in the uploaded file ! Please fix the errors marked in red by referring to the error notes added to the cells in the downloaded file", AlertDialogType.ERROR));
  }
}
